import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Layout from '../components/Layout';
import DashboardEnhanced from '../pages/DashboardEnhanced';
import Members from '../pages/Members';
import Member360Enhanced from '../pages/Member360Enhanced';
import Member360Comprehensive from '../pages/Member360Comprehensive';
import CarePlanPage from '../pages/CarePlan';
import OutreachCenter from '../pages/OutreachCenter';
import Authorizations from '../pages/Authorizations';
import Programs from '../pages/Programs';
import Quality from '../pages/Quality';
import AssessmentFormEditor from '../pages/AssessmentFormEditor';
import MemberAssessments from '../pages/MemberAssessments';
import AssessmentFormFill from '../pages/AssessmentFormFill';
import ColorSystemGuide from '../pages/ColorSystemGuide';
import { AdminDashboard } from '../pages/AdminDashboard';
import DocToHtmlPreview from '../pages/DocToHtmlPreview';
import { LayoutOld } from "../components/LayoutOld";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-2xl font-bold text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <>
      {user?.role === 'admin' && (
        <Routes>
          <Route path="/dashboard" element={<Layout><DashboardEnhanced /></Layout>} />
          <Route path="/members" element={<Layout><Members /></Layout>} />
          <Route path="/members/:memberId" element={<Layout><Member360Enhanced /></Layout>} />
          <Route path="/members/:memberId/comprehensive" element={<Layout><Member360Comprehensive /></Layout>} />
          <Route path="/care-plans" element={<Layout><CarePlanPage /></Layout>} />
          <Route path="/outreach" element={<Layout><OutreachCenter /></Layout>} />
          <Route path="/authorizations" element={<Layout><Authorizations /></Layout>} />
          <Route path="/programs" element={<Layout><Programs /></Layout>} />
          <Route path="/quality" element={<Layout><Quality /></Layout>} />
          <Route path="/assessments/admin" element={<Layout><AdminDashboard onNavigate={() => { }} /></Layout>} />
          <Route path="/assessments/editor/:templateId" element={<Layout><AssessmentFormEditor /></Layout>} />
          <Route path="/assessments/member" element={<Layout><MemberAssessments /></Layout>} />
          <Route path="/assessments/fill/:assessmentId" element={<Layout><AssessmentFormFill /></Layout>} />
          <Route path="/design-system/colors" element={<Layout><ColorSystemGuide /></Layout>} />
          <Route path="/doc-preview" element={<Layout><DocToHtmlPreview /></Layout>} />
        </Routes>
      )}
      {user?.role !== 'admin' && (
        <Routes>
          <Route path="/dashboard" element={<LayoutOld><AdminDashboard onNavigate={() => { }} /></LayoutOld>} />
        </Routes>
      )}
    </>
  );
}
